import { ReactNode } from "react";

export const capitalizeFull = (str: string | undefined): string => {
  if (!str) {
    return "";
  }

  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const PageLayout: React.FC<{ title: string, children: ReactNode }> = ({ title, children }) => (
  <div className="pt-16 px-4 sm-px-6 lg-px-8">
    <main className="max-w-7xl mx-auto py-6">
      <div style={{ backgroundColor: 'white', padding: '2rem', borderRadius: '0.75rem', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
        <h1 style={{ fontSize: '1.875rem', fontWeight: 'bold', color: '#1f2937', marginBottom: '1rem' }}>{title}</h1>
        {children}
      </div>
    </main>
  </div>
);